"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusVisibleIndicator = exports.focusIndicatorStyles = void 0;
var tslib_1 = require("tslib");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var TabStyles_1 = require("./TabStyles");
exports.focusIndicatorStyles = function (color) {
    if (color === void 0) { color = TabStyles_1.TabStyles.Colors.Focus; }
    return Object.freeze({
        boxShadow: "0 0 4px 0 " + color,
        outline: "1px solid " + color + " !important",
        outlineOffset: -1,
        $nest: {
            '&::-moz-focus-inner': { $unique: true, border: 'none' }
        }
    });
};
exports.FocusVisibleIndicator = TypeStyle.style({
    $debugName: 'focus-visible-indicator',
    $nest: {
        '&:focus-visible': exports.focusIndicatorStyles(),
    }
});
//# sourceMappingURL=FocusIndicators.js.map